import NhapDiemThiPage from './NhapDiemThiPage';
export default NhapDiemThiPage;
